(function () {
  // Set to false to disable debug messages
  const DEBUG_MODE = false;

  // Initialize on DOM load
  if (DEBUG_MODE) console.log("[INFO] content-formatter-tabs.js loaded");
  document.addEventListener("DOMContentLoaded", initFormatter);
  window.addEventListener("load", initFormatter);

  function initFormatter() {
    addFormattingStyles();
    const allPanels = document.querySelectorAll(".product-tab--panel");
    if (DEBUG_MODE)
      console.log(
        "[INFO] Found .product-tab--panel elements:",
        allPanels.length
      );
    allPanels.forEach(formatContent);
  }

  function formatContent(panel) {
    if (!panel || !panel.textContent.trim()) {
      return;
    }

    const panelId = panel.id || "";
    const tabButton = document.querySelector(
      `.product-tab--button[data-tab="${panelId}"]`
    );
    const sectionTitle = tabButton
      ? tabButton.textContent.trim().toUpperCase().replace(/['']/g, "")
      : "";

    let originalText = panel.textContent.trim();
    // Add line breaks after exclamation points and USA flag
    originalText = originalText.replace(/\b(made in usa)\b/gi, "$1 🇺🇸");
    originalText = originalText.replace(/!(\s)/g, "!\n");

    const isWhatsInside = /WHAT(\W|_)?S INSIDE/i.test(sectionTitle);
    const keyIngredientsPattern = /Key Ingredients:/i;
    const hasKeyIngredients = keyIngredientsPattern.test(originalText);
    const isFragrance =
      /FRAGRANCE/i.test(sectionTitle) ||
      /Fragrance-free|Scent|Aroma|Notes/i.test(originalText);
    const isHowToUse = /HOW TO USE/i.test(sectionTitle);

    if (panel.classList.contains("formatted")) {
      if (DEBUG_MODE)
        console.log("[INFO] Panel already formatted, skipping...");
      return;
    }

    if (isWhatsInside) {
      if (DEBUG_MODE) console.log('[INFO] Formatting "What\'s Inside" tab...');
      if (DEBUG_MODE)
        console.log("[DEBUG] Original text for What's Inside:", originalText);

      panel.innerHTML = "";
      const contentDiv = document.createElement("div");
      contentDiv.className = "formatted-content";

      // Break into raw items
      const textWithLinebreaks = originalText.replace(/\.(?=\s|$)/g, ".\n");
      let items = textWithLinebreaks
        .split(/[\r\n]+|(?<=oz\.)\s*(?=[A-Z\d])|(?<=oz\.)$/)
        .map((i) => i.trim())
        .filter((i) => i.length > 0)
        .map(
          (item) =>
            item
              .replace(/^\d+\.\s+/, "") // strip “1. ” or “2. ” bullets only
              .replace(/\s+/g, " ") // collapse spaces
              .replace(/(\d+(?:\.\d+)?)\s*oz\./i, "$1 oz.") // normalize decimals & “oz.”
        );

      if (DEBUG_MODE) console.log("[DEBUG] Split items:", items);

      // matches pure-weight lines like “.5 oz.”, “2 oz.”, “15.7 oz.”
      const weightOnlyRe = /^\d*\.?\d+\s*oz\.$/i;

      // merge any weight-only line with the very next (name) line
      const combinedItems = [];
      for (let k = 0; k < items.length; k++) {
        if (
          weightOnlyRe.test(items[k]) &&
          k + 1 < items.length &&
          !weightOnlyRe.test(items[k + 1])
        ) {
          combinedItems.push(`${items[k]} ${items[k + 1]}`);
          k++; // skip the next line
        } else {
          combinedItems.push(items[k]);
        }
      }

      if (DEBUG_MODE) console.log("[DEBUG] Combined items:", combinedItems);

      // render every combined item with a checkmark
      const productItems = [];
      combinedItems.forEach((item) => {
        const p = document.createElement("p");
        p.className = "whats-inside-line";

        const check = document.createElement("span");
        check.className = "whats-inside-checkmark";
        check.innerHTML = "✓";

        const span = document.createElement("span");
        span.textContent = " " + item;

        p.appendChild(check);
        p.appendChild(span);
        contentDiv.appendChild(p);
        productItems.push(item);
      });

      // restore multi-column if 4+ items
      if (productItems.length >= 4) {
        contentDiv.classList.add("multi-column-layout");
      }

      panel.appendChild(contentDiv);
      panel.classList.add("formatted");
      return;
    }

    if (sectionTitle === "PRODUCT BENEFITS" && hasKeyIngredients) {
      if (DEBUG_MODE)
        console.log("[INFO] Formatting benefits + ingredients...");
      handleKeyIngredients(originalText, panel);
    } else if (isFragrance) {
      if (DEBUG_MODE) console.log("[INFO] Formatting fragrance notes...");
      handleFragrance(originalText, panel);
    } else if (isHowToUse) {
      if (DEBUG_MODE) console.log("[INFO] Formatting how to use...");
      handleHowToUse(originalText, panel);
    } else {
      if (DEBUG_MODE) console.log("[INFO] Using default formatting...");
      handleDefault(originalText, panel);
    }

    panel.classList.add("formatted");
  }

  function handleKeyIngredients(originalText, panel) {
    const keyIngredientsPattern = /Key Ingredients:/i;
    const parts = originalText.split(keyIngredientsPattern);
    const benefitsText = parts[0].trim();
    const ingredientsText = parts[1] ? parts[1].trim() : "";

    const contentDiv = document.createElement("div");
    contentDiv.className = "formatted-content";

    if (benefitsText) {
      let benefitLines = benefitsText
        .split(/[\n\r]+/)
        .map((line) => line.trim())
        .filter((line) => line.length > 0);

      if (benefitLines.length <= 1) {
        benefitLines = extractBenefitLines(benefitsText);
      }

      benefitLines.forEach((line) => {
        const benefitPara = document.createElement("p");
        benefitPara.className = "benefit-line";

        const checkmark = document.createElement("span");
        checkmark.className = "benefit-checkmark";

        if (/cruelty free/i.test(line)) {
          const img = document.createElement("img");
          img.src =
            "https://dionisgmskincare.com/cdn/shop/files/Cruelty-free_de2fa242-448c-47e0-aee4-9740132aee19_medium.png?v=1662477517";
          img.className = "leaping-bunny-icon";
          checkmark.appendChild(img);
        } else if (/Made in the USA/i.test(line)) {
          checkmark.innerHTML = "🇺🇸";
        } else {
          checkmark.innerHTML = "✓";
        }

        const textSpan = document.createElement("span");
        textSpan.textContent = " " + line;

        benefitPara.appendChild(checkmark);
        benefitPara.appendChild(textSpan);
        contentDiv.appendChild(benefitPara);
      });

      // Apply multi-column layout if 4 or more benefits
      if (benefitLines.length >= 4) {
        contentDiv.classList.add("multi-column-layout");
      }
    }

    const ingredientsDiv = document.createElement("div");
    ingredientsDiv.className = "ingredients-content"; // Single-column for ingredients

    const header = document.createElement("p");
    header.className = "ingredients-header";
    header.textContent = "Key Ingredients:";
    ingredientsDiv.appendChild(header);

    if (ingredientsText) {
      let descriptionText = "";
      let packagingText = "";
      let remainingIng = ingredientsText;

      if (/Packaged in/i.test(remainingIng)) {
        const packagingMatch = remainingIng.match(/Packaged in[^.]*\./i);
        if (packagingMatch) {
          packagingText = packagingMatch[0];
          remainingIng = remainingIng.replace(packagingMatch[0], "").trim();
        }
      }

      const descriptionPatterns = [
        /Goat milk, loaded/i,
        /loaded with/i,
        /rich in/i,
        /helps to/i,
        /preserves your/i,
        /maintains/i,
        /supports/i,
        /nourishes/i,
        /hydrates/i,
        /soothes/i,
      ];

      let descriptionStart = -1;
      for (const pattern of descriptionPatterns) {
        const matchPos = remainingIng.search(pattern);
        if (matchPos > -1) {
          descriptionStart = matchPos;
          break;
        }
      }

      let ingredientsList = [];
      if (descriptionStart > -1) {
        // Split the text at the start of the description
        descriptionText = remainingIng.substring(descriptionStart).trim();
        remainingIng = remainingIng.substring(0, descriptionStart).trim();
      }

      const splittedIng = remainingIng
        .split(/[,&;\-\n\r]+/)
        .map((i) => i.trim())
        .filter((i) => i.length > 0);

      ingredientsList = splittedIng.filter(
        (ingredient) =>
          !/loaded with|rich in|helps to|preserves|maintains|supports|nourishes|hydrates|soothes/i.test(
            ingredient
          )
      );

      // render each ingredient on its own line, with a bullet icon
      ingredientsList.forEach((item) => {
        // create the wrapper <p>
        const p = document.createElement("p");
        p.className = "ingredient-line";

        // create the icon span
        const bullet = document.createElement("span");
        bullet.className = "ingredient-checkmark";
        // goat emoji for “Goat milk”, checkmark for everything else
        bullet.innerHTML = /\bgoat milk\b/i.test(item) ? "🐐" : "✓";

        // create the text span
        const txt = document.createElement("span");
        txt.textContent = " " + item; // leading space before text

        // assemble and append to ingredientsDiv
        p.appendChild(bullet);
        p.appendChild(txt);
        ingredientsDiv.appendChild(p);
      });

      if (descriptionText) {
        const descPara = document.createElement("p");
        descPara.className = "description-text";
        descPara.textContent = descriptionText.replace(
          /\b(goat milk)\b/gi,
          "🐐 $1"
        );
        ingredientsDiv.appendChild(descPara);
      }

      if (packagingText) {
        const pkgPara = document.createElement("p");
        pkgPara.className = "packaging-text";
        pkgPara.textContent = packagingText;
        ingredientsDiv.appendChild(pkgPara);
      }
    }

    panel.innerHTML = "";
    panel.appendChild(contentDiv);
    panel.appendChild(ingredientsDiv);
  }

  function handleFragrance(originalText, panel) {
    if (DEBUG_MODE)
      console.log("[INFO] handleFragrance - input:", originalText);

    const contentDiv = document.createElement("div");
    contentDiv.className = "formatted-content";

    // Split on blank lines so each scent entry stays together
    const entries = originalText
      .split(/\n\s*\n/)
      .map((e) => e.trim())
      .filter((e) => e.length > 0);

    if (DEBUG_MODE) console.log("[INFO] handleFragrance - entries:", entries);

    entries.forEach((entry) => {
      // collapse wraps into spaces, then break at periods
      const clean = entry
        .replace(/[\r\n]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
      const html = clean.replace(/\.(?=\s|$)/g, ".<br>");

      const p = document.createElement("p");
      p.className = "fragrance-line";

      const flower = document.createElement("span");
      flower.className = "fragrance-flower";
      flower.innerHTML = "❀";

      const span = document.createElement("span");
      span.innerHTML = " " + html;

      p.appendChild(flower);
      p.appendChild(span);
      contentDiv.appendChild(p);
    });

    if (entries.length >= 4) {
      contentDiv.classList.add("multi-column-layout");
    }

    panel.innerHTML = "";
    panel.appendChild(contentDiv);

    if (DEBUG_MODE) console.log("[INFO] handleFragrance - done");
  }

  function handleHowToUse(originalText, panel) {
    if (DEBUG_MODE) console.log("[INFO] Formatting how to use...");
    if (DEBUG_MODE)
      console.log("[DEBUG] Original text for How to Use:", originalText);

    const contentDiv = document.createElement("div");
    contentDiv.className = "formatted-content";

    const header = document.createElement("p");
    header.className = "directions-header";
    header.textContent = "Directions:";
    contentDiv.appendChild(header);

    // Preserve line breaks and blank lines exactly as they appear
    const rawLines = originalText.split(/\n/g);

    rawLines.forEach((line) => {
      const trimmed = line.trim();

      // If it's a blank line, insert an empty <p> for spacing
      if (trimmed === "") {
        const spacer = document.createElement("p");
        spacer.className = "how-to-spacer";
        spacer.innerHTML = "&nbsp;";
        contentDiv.appendChild(spacer);
      } else {
        const para = document.createElement("p");
        para.className = "content-paragraph";
        para.textContent = trimmed;
        contentDiv.appendChild(para);
      }
    });

    panel.innerHTML = "";
    panel.appendChild(contentDiv);
  }

  function handleDefault(originalText, panel) {
    if (DEBUG_MODE) console.log("[INFO] Using default formatting...");
    if (DEBUG_MODE)
      console.log("[DEBUG] Original text for default tab:", originalText); // Debug log
    const contentDiv = document.createElement("div");
    contentDiv.className = "formatted-content";

    let lines = originalText
      .split(/[\n\r]+|(?<=!)\s*(?=[A-Z])/)
      .map((line) => line.trim())
      .filter((line) => line.length > 0);

    let benefitLines = [];
    let ingredients = [];
    let descriptionText = "";

    const commonBenefits = [
      "Cruelty Free",
      "Clean Ingredients",
      "Paraben Free",
      "Dermatologist Tested",
      "Gentle on your skin",
      "Gentle for your skin",
      "Great for all skin types",
      "Non-GMO",
      "Vegan",
      "Organic",
      "Natural",
      "Eco-Friendly",
      "Sustainable",
      "Recyclable",
      "Biodegradable",
      "Sulfate Free",
      "Phthalate Free",
      "Gluten Free",
      "Non-greasy",
      "Gender neutral",
      "Made in the USA",
      "Made with goat milk",
      "Travel-sized routine for dry or oily skin",
      "Delivers long-lasting hydration while keeping skin balanced for a healthy-looking complexion",
      "Effectively reduce the appearance of fine lines and wrinkles",
      "Visibly reduces the look of pores",
      "Safe for sensitive skin",
    ];

    const ingredientKeywords = [
      "Goat Milk",
      "Squalane",
      "Peptides",
      "Hyaluronic Acid",
      "Vitamin C",
      "Niacinamide",
      "Retinol",
      "Aloe Vera",
      "Shea Butter",
      "Coconut Oil",
    ];

    lines.forEach((line) => {
      const descPatterns = [
        /Goat milk, loaded/i,
        /loaded with/i,
        /rich in/i,
        /helps to/i,
        /preserves your/i,
        /maintains/i,
        /supports/i,
        /nourishes/i,
        /hydrates/i,
        /soothes/i,
      ];

      let isDescription = false;
      for (const pat of descPatterns) {
        if (pat.test(line)) {
          descriptionText += (descriptionText ? " " : "") + line;
          isDescription = true;
          break;
        }
      }
      if (isDescription) return;

      if (/Made with/i.test(line)) {
        let ingText = line.replace(/Made with/i, "").trim();
        ingredients = ingText
          .split(/[,&;\-\n\r]+/)
          .map((i) => i.trim())
          .filter((i) => i.length > 0);
        return;
      }

      let matchedBenefit = false;
      for (const benefit of commonBenefits) {
        if (new RegExp(benefit, "i").test(line)) {
          benefitLines.push(line);
          matchedBenefit = true;
          break;
        }
      }
      if (matchedBenefit) return;

      let matchedIng = false;
      for (const ing of ingredientKeywords) {
        if (new RegExp(`\\b${ing}\\b`, "i").test(line)) {
          ingredients.push(line);
          matchedIng = true;
          break;
        }
      }
      if (matchedIng) return;

      // If the line doesn't match benefits, ingredients, or descriptions, treat it as a description
      descriptionText += (descriptionText ? " " : "") + line;
    });

    benefitLines.forEach((line) => {
      const para = document.createElement("p");
      para.className = "benefit-line";

      const checkmark = document.createElement("span");
      checkmark.className = "benefit-checkmark";

      if (/cruelty free/i.test(line)) {
        const img = document.createElement("img");
        img.src =
          "https://dionisgmskincare.com/cdn/shop/files/Cruelty-free_de2fa242-448c-47e0-aee4-9740132aee19_medium.png?v=1662477517";
        img.className = "leaping-bunny-icon";
        checkmark.appendChild(img);
      } else if (/Made in the USA/i.test(line)) {
        checkmark.innerHTML = "🇺🇸";
      } else {
        checkmark.innerHTML = "✓";
      }

      const textSpan = document.createElement("span");
      textSpan.textContent = " " + line;

      para.appendChild(checkmark);
      para.appendChild(textSpan);
      contentDiv.appendChild(para);
    });

    if (benefitLines.length >= 4) {
      contentDiv.classList.add("multi-column-layout");
    }

    const ingredientsDiv = document.createElement("div");
    ingredientsDiv.className = "ingredients-content"; // Single-column for ingredients

    if (ingredients.length > 0) {
      const ingHeader = document.createElement("p");
      ingHeader.className = "ingredients-header";
      ingHeader.textContent = "Key Ingredients:";
      ingredientsDiv.appendChild(ingHeader);

      ingredients.forEach((ingredient) => {
        const ingPara = document.createElement("p");
        ingPara.className = "ingredient-line";

        const checkmark = document.createElement("span");
        checkmark.className = "ingredient-checkmark";
        checkmark.innerHTML = "✓";

        const textSpan = document.createElement("span");
        textSpan.textContent = " " + ingredient;

        ingPara.appendChild(checkmark);
        ingPara.appendChild(textSpan);
        ingredientsDiv.appendChild(ingPara);
      });
    }

    if (descriptionText) {
      const descPara = document.createElement("p");
      descPara.className = "description-text";
      descPara.textContent = descriptionText.replace(
        /\b(goat milk)\b/gi,
        "🐐 $1"
      );
      ingredientsDiv.appendChild(descPara);
    }

    panel.innerHTML = "";
    panel.appendChild(contentDiv);
    if (ingredients.length > 0 || descriptionText) {
      panel.appendChild(ingredientsDiv);
    }
  }

  function extractBenefitLines(text) {
    const commonBenefits = [
      "Cruelty Free",
      "Clean Ingredients",
      "Paraben Free",
      "Dermatologist Tested",
      "Gentle on your skin",
      "Gentle for your skin",
      "Great for all skin types",
      "Non-GMO",
      "Vegan",
      "Organic",
      "Natural",
      "Eco-Friendly",
      "Sustainable",
      "Recyclable",
      "Biodegradable",
      "Sulfate Free",
      "Phthalate Free",
      "Gluten Free",
      "Non-greasy",
      "Gender neutral",
      "Made in the USA",
      "Made with goat milk",
      "Travel-sized routine for dry or oily skin",
      "Delivers long-lasting hydration while keeping skin balanced for a healthy-looking complexion",
      "Effectively reduce the appearance of fine lines and wrinkles",
      "Visibly reduces the look of pores",
      "Safe for sensitive skin",
    ];

    let foundBenefits = [];
    let remainingText = text;

    commonBenefits.forEach((benefit) => {
      const regex = new RegExp(benefit, "i");
      if (regex.test(remainingText)) {
        const match = remainingText.match(regex);
        if (match) {
          foundBenefits.push(match[0]);
          remainingText = remainingText.replace(regex, "");
        }
      }
    });

    if (foundBenefits.length > 0) {
      return foundBenefits;
    }

    const separators = /[;\-\n\r]+|(?<=!)\s*(?=[A-Z])/;
    if (separators.test(text)) {
      return text
        .split(separators)
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
    }

    const words = text.split(/\s+/);
    const benefits = [];
    let current = "";

    words.forEach((word) => {
      if (/^[A-Z]/.test(word) && current.length > 0) {
        benefits.push(current.trim());
        current = word;
      } else {
        current += (current ? " " : "") + word;
      }
    });
    if (current) {
      benefits.push(current.trim());
    }
    return benefits;
  }

  function addFormattingStyles() {
    if (document.getElementById("content-formatter-styles")) {
      return;
    }
    const styleEl = document.createElement("style");
    styleEl.id = "content-formatter-styles";

    styleEl.textContent = `
      /* Improved mobile formatting styles */
      .product-tab--panel {
        padding: 0 0 15px !important;
      }
      .formatted-content {
        padding: 0 25px;
        text-align: left;
      }
      .ingredients-content {
        padding: 0 25px;
        text-align: left;
        margin-top: 20px; /* Increased spacing between list and content below */
      }
      .benefit-line {
        margin: 4px 0; /* Tightened spacing between list items */
        line-height: 1.4;
        display: flex;
        align-items: flex-start;
      }
      .benefit-checkmark {
        color: #b88b76 !important; /* Swapped: darker brown for checkmark */
        font-weight: bold;
        flex-shrink: 0;
        margin-right: 8px;
        width: 20px;
        height: 20px;
        background-color: #F0EADC; /* Swapped: light color for background */
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
      .whats-inside-line {
        margin: 4px 0; /* Tightened spacing between lines */
        line-height: 1.4;
        display: flex;
        align-items: center;
      }
      .whats-inside-checkmark {
        color: #b88b76 !important; /* Swapped: darker brown for checkmark */
        font-weight: bold;
        margin-right: 8px;
        flex-shrink: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 30px;
        width: 20px;
        height: 20px;
        background-color: #F0EADC; /* Swapped: light color for background */
        border-radius: 50%;
      }
      .ingredient-line {
        margin: 4px 0; /* Tightened spacing between list items */
        line-height: 1.4;
        display: flex;
        align-items: flex-start;
      }
      .ingredient-checkmark {
        color: #b88b76 !important; /* Swapped: darker brown for checkmark */
        margin-right: 8px;
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        background-color: #F0EADC; /* Swapped: light color for background */
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
      .ingredients-header {
        margin: 12px 0 6px;
        line-height: 1.4;
        font-weight: 500;
      }
      .description-text {
        margin: 8px 0;
        line-height: 1.5;
      }
      .packaging-text {
        margin: 8px 0;
        line-height: 1.5;
        font-style: italic;
      }
      .fragrance-line {
        margin: 8px 0; /* Enlarged spacing for fragrance notes */
        line-height: 1.4;
        display: flex;
        align-items: flex-start;
      }
      .fragrance-flower {
        color: #b88b76 !important; /* Swapped: darker brown for flower */
        margin-right: 8px;
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        background-color: #F0EADC; /* Swapped: light color for background */
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
      .leaping-bunny-icon {
        width: 20px;
        height: 20px;
        background-color: #F0EADC;
        border-radius: 50%;
        display: inline-block;
        filter: hue-rotate(20deg) saturate(80%) brightness(90%); /* Adjust to approximate #b88b76 */
      }
      .directions-header {
        margin: 12px 0 6px;
        line-height: 1.4;
        font-weight: bold;
      }
      .content-paragraph {
        margin: 6px 0;
        line-height: 1.5;
      }
      /* FIXED: Changed three-columns to multi-column-layout for better consistency */
      .multi-column-layout {
        display: grid;
        gap: 10px;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      }
      @media only screen and (min-width: 768px) {
        .multi-column-layout {
          grid-template-columns: repeat(3, 1fr); /* Desktop: 3 columns */
        }
        .product-tab--panel .formatted-content,
        .product-tab--panel .ingredients-content {
          max-width: 600px; /* Match the parent max-width to prevent overflow */
          margin: 0 auto;
        }
        .product-tab--panel .formatted-content p,
        .product-tab--panel .ingredients-content p {
          text-align: left;
        }
      }
      @media only screen and (max-width: 767px) {
        .multi-column-layout {
          grid-template-columns: repeat(2, 1fr); /* FIXED: Two columns on mobile */
          gap: 8px; /* Slightly smaller gap for mobile */
        }
        .product-tab--panel .formatted-content,
        .product-tab--panel .ingredients-content {
          max-width: 100%; /* Full width on mobile */
          padding: 0 15px; /* Reduced padding for mobile */
        }
      }
      @media only screen and (max-width: 480px) {
        .multi-column-layout {
          grid-template-columns: repeat(2, 1fr); /* FIXED: Keep two columns on very small screens */
          gap: 6px;
        }
      }
    `;
    document.head.appendChild(styleEl);
    if (DEBUG_MODE) console.log("[INFO] Added formatting styles");
  }

  function setupTabObserver() {
    const tabButtons = document.querySelectorAll(".product-tab--button");
    tabButtons.forEach((button) => {
      button.addEventListener("click", function () {
        const targetId = this.getAttribute("data-tab");
        if (targetId) {
          const targetPanel = document.getElementById(targetId);
          if (targetPanel && !targetPanel.classList.contains("formatted")) {
            if (DEBUG_MODE)
              console.log(`[INFO] Formatting newly activated tab: ${targetId}`);
            formatContent(targetPanel);
          }
        }
      });
    });
  }

  // Enable observer for dynamic content
  function observePageChanges() {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          for (let i = 0; i < mutation.addedNodes.length; i++) {
            const node = mutation.addedNodes[i];
            if (node.nodeType === 1) {
              // Only process Element nodes
              if (
                node.classList &&
                node.classList.contains("product-tab--panel")
              ) {
                if (DEBUG_MODE)
                  console.log(
                    "[INFO] New panel detected and will be formatted"
                  );
                formatContent(node);
              }

              // Check for any panels within the added node
              const panels = node.querySelectorAll(".product-tab--panel");
              if (panels.length > 0) {
                if (DEBUG_MODE)
                  console.log(
                    "[INFO] Found panels within dynamically added content"
                  );
                panels.forEach(formatContent);
              }
            }
          }
        }
      });
    });

    // Observe the entire document for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    if (DEBUG_MODE) console.log("[INFO] Page observer initialized");
  }

  // Run our setup functions
  setupTabObserver();
  observePageChanges();

  // Expose formatter for manual use if needed
  window.dionisMobileFormatter = {
    formatContent: formatContent,
    formatAllPanels: function () {
      const allPanels = document.querySelectorAll(".product-tab--panel");
      allPanels.forEach(formatContent);
    },
  };

  if (DEBUG_MODE)
    console.log(
      "[INFO] Dionis Goat Milk Skincare Tabs content formatter initialized successfully"
    );
})();
